<template>
  <WdsStack gap-sm direction-column>
    <WdsSelect
      v-model="selectedStatuses"
      multi-select
      searchable
      :label="meta.filter.quickFilter ? '' : $t('Worker payout status')"
      :list="statusOptions"
      :placeholder="$t('All payout statuses')"
      can-deselect
      labels-primary
    />
  </WdsStack>
</template>

<script setup lang="ts">
import { WdsSelect, WdsStack } from '@worksome/wds-components'
import { computed, ModelRef } from 'vue'
import { $t } from '@/composables/translation'
import { PaymentRequestWorkerPayoutStatus } from '@/gql/graphql'
import { FilterMetaDataProp } from '@/components/GraphqlDataTable/filters/types'

defineProps<{ meta: FilterMetaDataProp }>()

const selectedStatuses: ModelRef<string[]> = defineModel({
  type: Array,
  default: () => [],
})

const orderedStatuses = [
  PaymentRequestWorkerPayoutStatus.Paid,
  PaymentRequestWorkerPayoutStatus.Prepaid,
  PaymentRequestWorkerPayoutStatus.Due,
  PaymentRequestWorkerPayoutStatus.Overdue,
]

const statusLabels: Partial<Record<PaymentRequestWorkerPayoutStatus, string>> = {
  [PaymentRequestWorkerPayoutStatus.Paid]: 'Paid',
  [PaymentRequestWorkerPayoutStatus.Prepaid]: 'Prepaid',
  [PaymentRequestWorkerPayoutStatus.Due]: 'Due',
  [PaymentRequestWorkerPayoutStatus.Overdue]: 'Overdue',
}

const statusOptions = computed(() =>
  orderedStatuses.map((status) => ({
    label: $t(statusLabels[status]),
    value: status,
  })),
)
</script>

